import { useLanguage } from '../utils/languageContext';
export default function Footer() {
    const { t } = useLanguage();
    return (
        <footer className="footer-loginn">
            <p>
                {t("footer_text")}
            </p>
        </footer>
    );
}